/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * SIN-PERF environment settings
 *
 * @file sinperf.js
 * @author Balaji Ganesh
 * @since 1.0.0
 */

import base from './base';

const sinperf = {
  GLS_API_BASE_URL: 'https://api-sin-perf.gls.pearson-intl.com/product'
};

export default {
  ...base,
  ...sinperf
};
